module.exports = __webpack_public_path__ + "build/desktop/a/img/plane-icon.857bcc900c00d522ba1e632c541f6ce7.svg";